import { Button, Grid, Paper } from "@mui/material";
import { useSnackbar } from "notistack";
import React from "react";
import { useNavigate } from "react-router-dom";
import { ApiError } from "../../Api/ApiError";
import { getAdminStore } from "../../Api/Staff";
import { StoreData } from "../../Objects/StoreInterface";
import CategoryTitle from "../atoms/CategoryTitle";
import StoreCard from "../molecules/StoreCard";
import StoreSettingEditDialog from "./StoreSettingEditDialog";

const StoreList: React.FC = () => {
    let { enqueueSnackbar } = useSnackbar()
    let navigate = useNavigate()
    const [storeList, setStoreList] = React.useState<StoreData[]>()
    const [addStore, setAddStore] = React.useState<boolean>(false)

    const abortController = React.useMemo(() => new AbortController(), [])

    React.useEffect(() => {
        return () => {
            abortController.abort()
        }
    }, [abortController])

    const loadAdminStore = React.useCallback(() => {
        getAdminStore({signal: abortController.signal}).then(({ list }: { list: StoreData[] }) => {
            setStoreList(list)
        }).catch((e: any) => {
            if( e.__CANCEL__ ) {
                console.info("canceled")
            } else if (e instanceof ApiError) {
                enqueueSnackbar(e.message, { variant: "error" })
            } else if (e instanceof Error) {
                enqueueSnackbar(e.message, { variant: "error" })
            }else {
                enqueueSnackbar("通信に失敗しました", { variant: "error" })
            }
        })
    }, [abortController, enqueueSnackbar])


    /**
     * 管理店舗を取得
     */
    React.useEffect(() => {
        loadAdminStore()
    }, [loadAdminStore])
    
    return (
        <Paper>
            <CategoryTitle text="店舗一覧"/>
            <Grid container spacing={2} sx={{ padding: "0 14px 14px 14px", marginTop: "14px" }}>
                <Grid item xs={12} textAlign="right">
                    <Button
                        variant="contained"
                        onClick={() => {
                            setAddStore(true)
                        }}
                    >店舗を追加</Button>
                </Grid>
                {storeList?.map((storeData: StoreData, index: number) => {
                    return (
                        <Grid item xs={12} sm={6} md={4} key={index}>
                            <StoreCard
                                storeData={storeData}
                                onClick={()=>{
                                    navigate('/store/'+storeData.str_id)
                                }}
                            />
                        </Grid>
                    )
                })}
            </Grid>
            <StoreSettingEditDialog
                storeId={addStore ? 0 : undefined}
                onClose={(isEdit) => {
                    if( isEdit ) {
                        loadAdminStore()
                    }
                    setAddStore(false)
                }}
            />
        </Paper>
    );
}

export default StoreList